export enum ReceiptStates {
  ATRAI = "ATRAI",
  EMISE = "EMISE",
  SOLDEE = "SOLDEE",
  SANSEF = "SANSEF",
  REJ = "REJ",
  REPRES = "REPRES",
  IMP = "IMP",
  AOFF = "AOFF",
  OFFERT = "OFFERT",
  REGUL = "REGUL",
  AVAN = "AVAN",
  ANNUL = "ANNUL",
  ANNUL2 = "ANNUL2",
  RECOUVR = "RECOUVR",
  ABAND = "ABAND",
}
